import type { CourseModule } from "@/core/types";
import { lektionAusrichtung } from "./lektion-01-ausrichtung";
import { lektionAbstaende } from "./lektion-02-abstaende";
import { lektionZeilenabstand } from "./lektion-03-zeilenabstand";
import { lektionEinzuege } from "./lektion-04-einzuege";
import { lektionListen } from "./lektion-05-listen";
import { lektionAbsaetzeAbschluss } from "./lektion-06-abschluss";

export const modulAbsaetze: CourseModule = {
  id: "absaetze",
  title: "Absätze, Abstände und Listen",
  summary:
    "Die zweite Formatierungsebene: Ausrichtung, Abstände und Einzüge richtig " +
    "einstellen – statt sie mit Leerzeilen und Leerzeichen nachzubauen.",
  level: "Grundlagen",
  lessons: [
    lektionAusrichtung,
    lektionAbstaende,
    lektionZeilenabstand,
    lektionEinzuege,
    lektionListen,
    lektionAbsaetzeAbschluss,
  ],
};
